@if (isError()) {
  <div class="error-section">
    <span class="error-icon">&#9888;</span>
    <span>{{ errorMessage() }}</span>
  </div>
} @else if (chartOptions()) {
  <div class="chart-wrapper">
    <div echarts [options]="chartOptions()!" [merge]="chartOptions()!" class="distribution-chart"></div>
  </div>
}
